export default "__VITE_ASSET__o7ffChu0__"